import(/* webpackMode: "eager" */ "/usr/src/app/src/app/@articleModal/(.)[slug]/a/[articleId]/error.tsx");
